<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <div class="active section">
                <a v-go-back="'contracts'">Contratos</a>
                <i class="right chevron icon divider"></i>
                <a :href="`/contracts/${contract.id}`">{{
                  `${contract.id} - ${contract.owner_name}`
                }}</a>
                <div class="section"></div>
                <i class="right chevron icon divider"></i>
                <div class="section">Associados</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <form @submit.prevent="search()" class="ui small form search-form">
              <div class="fields">
                <div class="six wide field">
                  <label for="contract-search-description">
                    Nome ou CPF do titular
                  </label>
                  <input
                    type="text"
                    name="contract-search-description"
                    v-model="searchForm.description"
                  />
                </div>
                <div class="six wide field">
                  <label for="contract-search-member">
                    Nome do beneficiário
                  </label>
                  <input
                    type="text"
                    name="contract-search-member"
                    v-model="searchForm.member"
                  />
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <Grid
              ref="grid"
              resource="contracts"
              @refresh="search()"
              @page="n => search(n)"
            />
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import ContractEnum from '@/enumerations/contract_enum';
import Feature from '@/utils/features';
import SearchMixins from '@/mixins/search_mixins';
import Grid from './grid';

export default {
  name: 'ContractAssociates',
  mixins: [SearchMixins],
  components: { Grid, Breadcrumb, PageLayout },

  data() {
    return {
      ContractEnum: ContractEnum,
      enableCardNumber: Feature.allows('card_number'),
      contract: {},
      searchForm: {
        description: null,
        cod: null,
        member: null
      },
      query: {}
    };
  },

  mounted() {
    this._initSearchForm();
    // this.search(this.$route.query.page);
    this.init();
  },

  methods: {
    async init() {
      await this.fetchContract(this.$route.params.contract_id);
      this.search(this.$route.query.page);
    },

    fetchContract(id) {
      this.loading = true;
      Api.contracts
        .fetch(id)
        .then(async response => {
          this.contract = response.data.contract;
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show('Erro ao buscar contrato', 'error');
            this.$router.push({ name: 'contracts' });
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    search(page = 1) {
      this._addSearchToQueryParams();

      const query = {
        q: {
          owner_cpf_or_owner_name_cont: this.searchForm.description,
          members_user_name_cont: this.searchForm.member,
          id_eq: this.searchForm.cod,
          s: ['created_at desc']
        },
        page: page
      };

      if (this.searchForm.state != null) {
        query.q.state_eq = this.searchForm.state;
      }

      this.$refs.grid.toggleLoading();
      Api.associates
        .search(this.$route.params.contract_id, query)
        .then(async response => {
          this.$refs.grid.setData(
            response.data.associates,
            response.data.pagination
          );
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar dados', 'error');
          throw error;
        })
        .finally(() => {
          this.$refs.grid.toggleLoading();
        });
    }
  }
};
</script>
